import React from 'react';
import { Text as RebassText } from '../Rebass';
import theme, { TextFontSize, TextFontWeight } from '../../theme';
import { TextProps as RebassTextProps } from '../Rebass/types';

export interface TextProps extends RebassTextProps {
  size?: TextFontSize;
  children?: React.ReactNode;
  color?: string;
  as?: any;
  sx?: any;
  css?: string;
  fontSize?: number | number[] | string | string[];
  fontWeight?: TextFontWeight;
  className?: string;
  target?: string;
  rel?: string;
  href?: string;
}

export const weight = {
  bold: {
    fontWeight: theme.fontWeights.bold,
  },
  normal: {
    fontWeight: theme.fontWeights.normal,
  },
  light: {
    fontWeight: theme.fontWeights.light,
  },
};

export const display = {
  extraSmall: {
    fontSize: ['extraSmall'],
    fontFamily: theme.fonts.sans,
  },
  caption: {
    fontSize: ['tiny'],
    fontFamily: theme.fonts.serif,
  },
  tiny: {
    fontSize: ['tiny'],
    fontFamily: theme.fonts.sans,
  },
  small: {
    fontSize: ['small'],
    fontFamily: theme.fonts.sans,
  },
  body: {
    fontSize: ['body'],
    fontFamily: theme.fonts.sans,
    fontWeight: 'light',
  },
  large: {
    fontSize: ['large'],
    fontFamily: theme.fonts.sans,
    fontWeight: 'light',
  },
};

const Text = ({
  children,
  size = 'body',
  as = 'span',
  fontWeight,
  ...rest
}: TextProps) => {
  const textProps = { ...display[size], ...weight[fontWeight], as, ...rest };
  return <RebassText {...textProps}>{children}</RebassText>;
};

Text.defaultProps = {
  size: 'body',
  lineHeight: 1.333,
  as: 'span',
  fontStyle: 'normal',
  color: 'textDark',
} as TextProps;

export default Text;
